import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { colors } from '../../theme/colors';

interface StorageConsumptionDisplayProps {
  limitBytes: number;
  usedBytes: number;
}

const formatBytes = (bytes: number): string => {
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

const StorageConsumptionDisplay: FC<StorageConsumptionDisplayProps> = ({
  limitBytes,
  usedBytes,
}) => {
  const { t } = useTranslation();
  const percentage =
    limitBytes > 0 ? Math.round((usedBytes / limitBytes) * 100) : 0;

  return (
    <Box
      maxWidth={540}
      sx={{ alignItems: 'center', display: 'flex', gap: 2, mb: 1, mt: 2 }}
    >
      <Typography
        color={colors['gray-700']}
        sx={{ minWidth: 120 }}
        variant="text-xs"
      >
        {t('storage-consumption')}
      </Typography>
      <Typography
        color={colors['gray-700']}
        sx={{ fontSize: '14px' }}
        variant="text-xs"
      >
        {formatBytes(usedBytes)} / {formatBytes(limitBytes)} ({percentage}%)
      </Typography>
    </Box>
  );
};

export default StorageConsumptionDisplay;
